// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tEBv","option":"styles_option__19KOr","selected":"styles_selected__tAbCG"};